import styled from "styled-components";

import { AddToWishlistNotificationStyledProps as Props } from "./AddToWishlistNotification.types";
import Notification from "components/global/notifications/Notification/Notification";
import CONSTANTS from "config/constants";

const { mobile } = CONSTANTS.BREAKPOINTS;

const AddToWishlistNotificationStyled = styled(Notification)<Props>`
  display: grid;
  grid-template-columns: 5.6rem auto 6.4rem;
  align-items: center;
  cursor: pointer;

  @media (max-width: ${mobile}px) {
    padding: 1.2rem;
  }

  .AddToWishlistNotification {
    &__description {
      font-size: 1.2rem;
      color: var(--palette-black-s0-l10);
      padding-left: 0.8rem;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
      width: 100%;
    }

    &__button {
      font-weight: 600;
      font-size: 1.4rem;

      @media (max-width: ${mobile}px) {
        padding: 0;
      }
    }
  }
`;

export default AddToWishlistNotificationStyled;
